/**
 * SurveyGenerator
 */
export const SurveyGenerator = (function () {

  var init =  function () {

    $('#myds-add-question').on('click', function(e) {
      addQuestion('question');
    });

    $('#myds-add-text-question').on('click', function(e) {
      addQuestion('text-question');
    });

    $('div').on('click', '#myds-add-option', function(e) {
      e.preventDefault();

      addOption(this);
    });
    // delete option
    $('div').on('click', '.delete-answer', function(e) {
      e.preventDefault();
      
      $(this).closest('[data-option]').remove();
    });
    // delete question
    $('div').on('click', '.delete-question', function(e) {
      e.preventDefault();
      
      $(this).closest('.card').remove();
      reorderQuestions();
    });

    $('div').on('click', '#myds-change-checkbox', function(e) {
      e.preventDefault();
      var checkboxes = $(this).closest('.card-body').find('.checkbox-control');
      var typeInput = 'radio';
      // change text of button
      $(this).text(function(i, text){
        return text === "Multiselect" ? "Singleselect" : "Multiselect";
      });
      // change the view of the checkbox between square and rounded
      $(checkboxes).each(function() {
        $(this).toggleClass('square');
      });

      if($(this).text() == 'Singleselect') {
        typeInput = 'checkbox';
      }
      // change the type of the input
      $(this).closest('.card-body').find('.myds-checkbox-input').prop('type', typeInput);
    });



  }

  var addQuestion = function(cardId) {
    var content = $('#myds-' + cardId).html();
    var btnAddQuestion = $(`[data-card]`).length == 0 ? $('.myds-add-btns') : $(`[data-card]`).last();
    var card = $('<div class="card mt-3 myds-question-card" data-card="question">');
    var index = $('.myds-question-card').length;

    content = content.replace(/number/g, index);
    card.html(content + '</div>');

    btnAddQuestion.after(card);
  }

  var addOption = function(btn) {
    let option = `<div class="d-flex align-items-center mb-2 myds-option" data-option="myds-answer-checkbox">
                    <label class="checkbox mb-0 myds-checkbox">
                        <input name="checkbox-answer" type="radio" class="myds-checkbox-input">
                        <span class="checkbox-control" data-radio="radio"></span>
                    </label>
                    <input type="text" name="option" class="form-control ml-2" aria-describedby="question" placeholder="Extra option">
                    <a class="delete-answer ml-2 mr-1" href="" aria-hidden="true"><strong>x</strong></a>
                  </div>`;
    $(option).insertBefore(btn);
  }

  var reorderQuestions = function() {
    $('.myds-question-card:visible').each(function(index, el) {
      let newIndex = index + 1;
      // changes the number of the question in the card and in the data-index attribute
      let questionNumber = $(this).find('[data-index]');
      questionNumber.attr('data-index', newIndex);
      questionNumber.text(newIndex + '.');
    });
  }

  var constructSurveyArrayObject = function () {
    let inputData = $("[data-card='question']");
    var survey = [];

    $(inputData).each(function(i, el){
      var optionsQuestions = [];
      let question = $(el).find('.myds-question');
      let options = $(el).find('input[name="option"]');
      let optionType = $(el).find('.myds-checkbox-input').attr('type');
      // check question value is not empty
      if ($(question).val() == '') {
        return Util.toggleAlert('#myds-alert-survey', 'Please fill all questions.', 'alert-primary', 8000);
      }

      $(options).each(function(index, optionEl){
        // check that all options are not empty
        if($(optionEl).val() == '') {
          return Util.toggleAlert('#myds-alert-survey', 'Please fill all options.', 'alert-primary', 8000);
        }

        optionsQuestions.push($(optionEl).val());
      });
      // creates array of objects with the questions
      survey.push({
        type: $(question).attr('name').split('-')[1],
        option_type: optionType != null ? optionType : 'textarea',
        question: $(question).val(),
        options: optionsQuestions
      });
      
    });

    return survey;
  }

  return {
    init: init,
    constructSurveyArrayObject: constructSurveyArrayObject
  }

}());


